export const BACKEND_SERVICE = process.env.REACT_APP_BACKEND_SERVICE;